<!-- <span class="filter-bar__title">Filters</span> -->
<section *ngFor="let aggr of categorizedAggregations; index as catIndex; trackBy: trackByMethod">
  <app-filter-category [title]="aggr.category" [totalSelected]="totalSelected(aggr?.items)">
    <div *ngFor="let a of aggr.items; index as i" [ngSwitch]="a?.Meta?.type">
      <app-aggregation-block
        [expanded]="false"
        [aggregation]="a"
        [activeKeys]="a?.selectedValues"
        (onChange)="buildBody($event)"
        *ngSwitchCase="'checkbox'"
      ></app-aggregation-block>
      <app-aggregation-block
        [expanded]="false"
        [aggregation]="a"
        (onChange)="buildBody($event)"
        *ngSwitchCase="'nested'"
      ></app-aggregation-block>
      <app-aggregation-slider
        [expanded]="false"
        [aggregation]="a"
        (onChange)="buildBody($event)"
        *ngSwitchCase="'range'"
      ></app-aggregation-slider>
      <app-aggregation-range
        [expanded]="false"
        [aggregation]="a"
        (onChange)="buildBody($event)"
        *ngSwitchCase="'dropdown'"
      ></app-aggregation-range>
    </div>
  </app-filter-category>
</section>
<div class="filter-bar__reset" *ngIf="getKeys(filters?.filters).length">
  <button class="button variant-dark-color" (click)="clearFilters()">Reset filters ({{ categoryTotal(categorizedAggregations) }})</button>
</div>
